:host {
  display: block;
  max-width: 100%;
  --apex-yaxis-label-color: var(--chart-300-icon-buttons);
  --apex-xaxis-label-color: var(--chart-300-icon-buttons);

  &::part(tooltip) {
    padding: calc(var(--spacer) * 2) calc(var(--spacer) * 3);
  }
  &::part(tooltip-title),
  &::part(tooltip-text) {
    font-family: var(--font-family-secondary), serif;
  }

  &::part(tooltip-value) {
    font-family: var(--font-family-secondary-mono), serif;
  }

  &::part(tooltip-text) {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  gz-dropdown {
    height: auto;
    width: auto;
  }
}
